/** Tune remote image URLs for faster LCP and lower bandwidth. */
export function optimizeImageUrl(url, { width = 1024, quality = 68 } = {}) {
  if (!url || typeof url !== "string") return url;

  if (url.includes("images.unsplash.com")) {
    const base = url.split("?")[0];
    return `${base}?w=${width}&q=${quality}&auto=format&fit=crop`;
  }

  if (url.includes("images.pexels.com")) {
    const base = url.split("?")[0];
    return `${base}?auto=compress&cs=tinysrgb&w=${width}`;
  }

  return url;
}
